import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:wght@900&family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap');

        .cta-section {
          margin: 0 5vw 64px;
          border-radius: 28px;
          background: linear-gradient(135deg, #1C1917 0%, #292524 45%, #1C1917 100%);
          padding: 64px 8vw;
          text-align: center;
          position: relative;
          overflow: hidden;
          border: 1px solid rgba(255,255,255,0.06);
          box-shadow: 0 32px 64px rgba(0,0,0,0.18);
        }
        .cta-glow {
          position: absolute; width: 460px; height: 460px; border-radius: 50%;
          background: radial-gradient(circle, #D97706 0%, transparent 70%);
          filter: blur(55px); opacity: 0.11;
          top: 50%; left: 50%; transform: translate(-50%,-50%);
          pointer-events: none;
          animation: cta-pulse 5s ease-in-out infinite;
        }
        .cta-grid {
          position: absolute; inset: 0;
          background-image: radial-gradient(circle, rgba(255,255,255,0.025) 1px, transparent 1px);
          background-size: 28px 28px; pointer-events: none;
        }
        .cta-btn-primary {
          padding: 15px 32px; border-radius: 12px; border: none;
          background: linear-gradient(135deg, #92400E, #D97706);
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 15px; font-weight: 700; color: #fff;
          cursor: pointer; transition: transform .2s, box-shadow .2s;
          box-shadow: 0 6px 22px rgba(180,83,9,.45);
        }
        .cta-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 10px 28px rgba(180,83,9,.55); }
        .cta-btn-secondary {
          padding: 15px 28px; border-radius: 12px;
          border: 1.5px solid rgba(255,255,255,0.14);
          background: rgba(255,255,255,0.04);
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 15px; font-weight: 700; color: #E7E5E4;
          cursor: pointer; transition: all .2s;
        }
        .cta-btn-secondary:hover { border-color: #D97706; color: #D97706; background: rgba(217,119,6,.08); }

        /* Footer horizontal layout */
        .site-footer {
          background: #FAF7F4;
          border-top: 1px solid #E7E5E4;
          padding: 28px 5vw;
        }
        .footer-inner {
          max-width: 1100px; margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 16px;
        }
        /* Left: brand */
        .footer-brand {
          display: flex; align-items: center; gap: 9px;
        }
        /* Center: tagline + dev badge stacked */
        .footer-center {
          display: flex; flex-direction: column;
          align-items: center; gap: 8px;
          flex: 1; text-align: center;
        }
        /* Right: socials + copyright */
        .footer-right {
          display: flex; flex-direction: column;
          align-items: flex-end; gap: 8px;
        }

        .footer-social-row { display: flex; gap: 8px; }
        .footer-social-icon {
          width: 33px; height: 33px; border-radius: 9px;
          border: 1.5px solid #E2DDD9;
          display: flex; align-items: center; justify-content: center;
          background: transparent; text-decoration: none;
          transition: border-color .2s, background .2s;
        }
        .footer-social-icon:hover { border-color: #D97706; background: rgba(217,119,6,.07); }
        .footer-social-icon img { width: 15px; height: 15px; display: block; }

        .dev-badge {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 5px 12px; border-radius: 999px;
          background: rgba(217,119,6,.08);
          border: 1px solid rgba(217,119,6,.22);
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 11.5px; font-weight: 700; color: #92400E;
          text-decoration: none; transition: all .2s;
        }
        .dev-badge:hover { background: rgba(217,119,6,.15); color: #D97706; border-color: #D97706; }
        .dev-dot {
          width: 5px; height: 5px; border-radius: 50%;
          background: #D97706; flex-shrink: 0;
          animation: badge-blink 2.4s ease-in-out infinite;
        }

        @keyframes cta-pulse {
          0%,100% { opacity:.10; transform:translate(-50%,-50%) scale(1); }
          50%      { opacity:.17; transform:translate(-50%,-50%) scale(1.08); }
        }
        @keyframes badge-blink {
          0%,100% { opacity:1; } 50% { opacity:.3; }
        }

        /* Mobile */
        @media (max-width: 640px) {
          .cta-section { margin: 0 12px 48px; border-radius: 20px; padding: 48px 20px; }
          .cta-btn-wrap { flex-direction: column; align-items: stretch; }
          .cta-btn-primary, .cta-btn-secondary { width: 100%; }
          .footer-inner { flex-direction: column; align-items: center; text-align: center; }
          .footer-right { align-items: center; }
        }
      `}</style>

      {/* ── CTA ── */}
      <section className="cta-section">
        <div className="cta-glow" />
        <div className="cta-grid" />
        <p style={{ fontSize:"10px", fontWeight:800, color:"#D97706", letterSpacing:"2px", textTransform:"uppercase", marginBottom:"14px", position:"relative" }}>
          Get Started Today
        </p>
        <h2 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(26px,4vw,50px)", fontWeight:900, color:"#FAFAF9", marginBottom:"14px", position:"relative", lineHeight:1.15 }}>
          Ready to get organised?
        </h2>
        <p style={{ fontSize:"15px", color:"#A8A29E", lineHeight:1.7, maxWidth:"380px", margin:"0 auto 36px", position:"relative" }}>
          Join Craftigo and take full control of your workforce today.
        </p>
        <div className="cta-btn-wrap" style={{ display:"flex", gap:"12px", justifyContent:"center", flexWrap:"wrap", position:"relative" }}>
          <button className="cta-btn-primary" onClick={() => navigate("/register")}>Create Free Account →</button>
          <button className="cta-btn-secondary" onClick={() => navigate("/login")}>Sign In</button>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="site-footer">
        <div className="footer-inner">

          {/* Left — Brand */}
          <div className="footer-brand">
            <div style={{ width:"32px", height:"32px", background:"linear-gradient(135deg,#92400E,#D97706)", borderRadius:"9px", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"16px", boxShadow:"0 3px 10px rgba(180,83,9,.28)", flexShrink:0 }}>🪚</div>
            <span style={{ fontFamily:"'Fraunces',serif", fontSize:"21px", fontWeight:900, color:"#1C1917" }}>Craftigo</span>
          </div>

          {/* Center — Tagline + Dev badge */}
          <div className="footer-center">
            <p style={{ fontSize:"12.5px", color:"#78716C", margin:0 }}>
              Smart Carpenter & Labour Management System
            </p>
            <a href="https://www.linkedin.com/in/saksham-sharma-1297a5290/" target="_blank" rel="noopener noreferrer" className="dev-badge">
              <div className="dev-dot" /> Developed by Saksham Sharma
            </a>
          </div>

          {/* Right — Socials + Copyright */}
          <div className="footer-right">
            <div className="footer-social-row">
              <a href="https://www.linkedin.com/in/saksham-sharma-1297a5290/" target="_blank" rel="noopener noreferrer" className="footer-social-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-original.svg" alt="LinkedIn" />
              </a>
              <a href="https://github.com/Saksham305-png" target="_blank" rel="noopener noreferrer" className="footer-social-icon">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" alt="GitHub" />
              </a>
            </div>
            <p style={{ fontSize:"12px", color:"#A8A29E", margin:0 }}>© 2026 Craftigo. All rights reserved.</p>
          </div>

        </div>
      </footer>
    </>
  );
}